import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { of, switchMap, take } from 'rxjs';

import { AuthService } from '@user/services/auth.service';
import { DataService } from '@user/services/data.service';
import { FooterComponent } from '@app/layout/components/footer/footer.component';
import { HeaderComponent } from '@app/layout/components/header/header.component';
import { TranslatePipe } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-dashboard',
    imports: [HeaderComponent, RouterOutlet, FooterComponent, RouterLink, RouterLinkActive, TranslatePipe],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
    private authService = inject(AuthService);
    private dataService = inject(DataService);

    ngOnInit(): void {
        const userId = this.authService.getUserId();
        if (userId) {
            this.dataService
                .getClinicInfoByUserAuthId(userId)
                .pipe(
                    switchMap((clinic) =>
                        clinic?.id
                            ? this.dataService.getVeterinariansByClinicId(clinic.id)
                            : of([]),
                    ),
                )
                .subscribe();
        }

        this.authService.getUserRole().pipe(take(1)).subscribe();
    }
}
